import React, { useState, useContext, useEffect } from "react";
import { motion } from "framer-motion";
import Logo2 from "../assets/img/Logo2.png";
import { cn } from "../../src/utils/utils";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../src/context/AuthContext";
import axios from "../axios/AxiosInstance";
import { message, Popconfirm } from "antd";

import {
  Home,
  Briefcase,
  ShoppingCart,
  Users,
  UserCheck,
  FileText,
  Library,
  Repeat,
  UserCircle,
  LogOutIcon,
  Building,
  logout,
  Bell,
  WatchIcon,
} from "lucide-react";

export default function Sidebar({ path }) {
  const [showAgencySwitch, setShowAgencySwitch] = useState(false); // Gère l'affichage de la modale
  const [selectedAgency, setSelectedAgency] = useState(null);
  const { setIsLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const [agencyName, setAgencyName] = useState("");

  const isActive = (chemin) => {
    return chemin === path;
  };

  useEffect(() => {
    const agencyName = localStorage.getItem("agencyName");
    setAgencyName(agencyName);
  }, []);

  const navGroups = [
    {
      title: "Principal",
      items: [
        {
          href: "/dashboard",
          icon: Home,
          label: "Tableau de bord",
        },
        {
          href: "/gestionDesTaches",
          icon: Briefcase,
          label: "Gestion des tâches",
        },
        {
          href: "/annonces",
          icon: Bell,
          label: "Annonces",
        },
      ]
    },
    {
      title: "Gestion",
      items: [
        { href: "/commandesPage", icon: ShoppingCart, label: "Commandes" },
        { href: "/candidatsPage", icon: UserCheck, label: "Candidats" },
        { href: "/contrats", icon: Repeat, label: "Contrats" },
        { href: "/clients", icon: Users, label: "Clients" },
      ]
    },
    {
      title: "Finances & RH",
      items: [
        {
          href: "/relevesdheures",
          icon: WatchIcon,
          label: "Relevés d'heures",
        },
        { href: "/facture", icon: FileText, label: "Factures" },
      ]
    },
    {
      title: "Outils",
      items: [
        { href: "/bibliotheque", icon: Library, label: "Bibliothèque" },
        { href: "/monCompte", icon: UserCircle, label: "Mon compte" },
      ]
    }
  ];

  // Fonction pour ouvrir la modale
  const handleSwitchAgencyClick = () => {
    setShowAgencySwitch(true); // Affiche la modale
  };

  const logout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem("accessToken");
    localStorage.removeItem("isLogged");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userRole");
    navigate("/");
  };

  // Fonction pour fermer la modale
  const closeAgencyModal = () => {
    setShowAgencySwitch(false); // Cache la modale
  };

  // Fonction pour changer d'agence
  const switchAgency = (agencyName, agencyId) => {
    console.log(agencyId);
    axios
      .post("agency/switch", { agency: agencyId })
      .then((res) => {
        console.log(res);
        setAgencyName(agencyName);
        navigate("dashboard");
        setShowAgencySwitch(false);
      })
      .catch((e) => {
        console.log(e);
        if (e.response.data.statusCode === 403) {
          message.error("Vous n'etes pas autorisé à changer d'agence !");
        }
      })
      .finally(() => {
        console.log("kkkkk");
      });
  };

  return (
    <motion.aside
      className="h-screen left-0 min-w-[280px] max-w-[280px] bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 flex flex-col shadow-2xl border-r border-slate-700/50"
      initial={{ x: -280 }}
      animate={{ x: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      {/* Logo et nom de l'agence */}
      <motion.div
        className="flex flex-col items-center py-4 bg-gradient-to-br from-blue-600 via-indigo-700 to-purple-800 text-white relative overflow-hidden particles-bg flex-shrink-0"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20 backdrop-blur-sm"></div>
        <div className="relative z-10 flex flex-col items-center">
          <motion.div
            className="relative"
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.3 }}
          >
            <img src={Logo2} className="w-12 h-12 object-contain rounded-full shadow-lg ring-2 ring-white/20" />
            <motion.div
              className="absolute -top-1 -right-1 w-5 h-5 bg-emerald-400 rounded-full shadow-lg"
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
            />
          </motion.div>
          <motion.h2
            className="text-lg font-bold tracking-tight mt-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            J'M INTERIM
          </motion.h2>
          <motion.div
            className="mt-1 flex items-center space-x-2 bg-white/10 px-2 py-1 rounded-full backdrop-blur-sm"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6 }}
          >
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            <p className="text-xs text-white/90 font-medium">{agencyName}</p>
          </motion.div>
        </div>
      </motion.div>

      {/* Menu items */}
      <nav className="flex-1 py-6 px-4 flex flex-col justify-between overflow-hidden">
        <div className="space-y-8 overflow-y-auto sidebar-scroll pr-2" style={{ maxHeight: 'calc(100vh - 280px)' }}>
          {navGroups.map((group, groupIndex) => (
            <motion.div
              key={groupIndex}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 + groupIndex * 0.1 }}
            >
              <div className="mb-4 px-3">
                <h3 className="text-xs uppercase text-slate-400 font-semibold tracking-widest flex items-center">
                  <span className="w-2 h-2 bg-slate-500 rounded-full mr-2"></span>
                  {group.title}
                </h3>
              </div>
              <ul className="space-y-1">
                {group.items.map((item, index) => {
              const Icon = item.icon;

              return (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: (groupIndex * 0.1) + (index * 0.05) }}
                >
                  <Link
                    to={item.href}
                    className={cn(
                      "group w-full flex items-center px-4 py-3 text-sm rounded-xl transition-all duration-300 ease-in-out relative overflow-hidden border border-transparent",
                      isActive(item.href)
                        ? "bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-600 text-white font-semibold shadow-lg border-blue-400/30 menu-item-active"
                        : "text-slate-300 hover:bg-slate-800/60 hover:text-white hover:border-slate-600/50 hover:shadow-md",
                    )}
                  >
                    {isActive(item.href) && (
                      <motion.div
                        className="absolute inset-0 bg-gradient-to-r from-blue-400/20 to-purple-400/20"
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ duration: 0.3 }}
                      />
                    )}
                    <span
                      className={cn(
                        "mr-3.5 flex-shrink-0 transition-all duration-300 relative z-10",
                        isActive(item.href)
                          ? "text-white scale-110 drop-shadow-sm"
                          : "text-slate-400 group-hover:text-white group-hover:scale-110",
                      )}
                    >
                      <Icon className="w-5 h-5" />
                    </span>
                    <span className="font-medium relative z-10 flex-1">{item.label}</span>
                    {isActive(item.href) && (
                      <motion.span
                        className="ml-auto bg-white/20 text-xs py-1 px-2 rounded-full backdrop-blur-sm relative z-10"
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ delay: 0.2 }}
                      >
                        ●
                      </motion.span>
                    )}
                    {!isActive(item.href) && (
                      <span className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-slate-400">
                        →
                      </span>
                    )}
                  </Link>
                </motion.li>
              );
            })}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Actions Section */}
        <div className="space-y-2 border-t border-slate-700/50 pt-3 flex-shrink-0">
          <div className="mb-2 px-3">
            <h3 className="text-xs uppercase text-slate-400 font-semibold tracking-widest">
              Actions
            </h3>
          </div>

          <motion.button
            onClick={handleSwitchAgencyClick}
            className="w-full flex items-center px-3 py-2 text-sm text-slate-300 hover:bg-slate-800/60 hover:text-white rounded-lg transition-all duration-300 group"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Building className="w-4 h-4 mr-3 text-slate-400 group-hover:text-blue-400 transition-colors duration-300" />
            <span className="font-medium">Switcher Agence</span>
            <span className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-slate-400">
              ⇄
            </span>
          </motion.button>

          <Popconfirm
            title="Êtes-vous sûr de vouloir vous déconnecter ?"
            onConfirm={logout}
            okText="Oui"
            cancelText="Non"
            placement="topRight"
          >
            <motion.button
              className="w-full flex items-center px-3 py-2 text-sm text-slate-300 hover:bg-red-900/30 hover:text-red-300 rounded-lg transition-all duration-300 group"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <LogOutIcon className="w-4 h-4 mr-3 text-slate-400 group-hover:text-red-400 transition-colors duration-300" />
              <span className="font-medium">Déconnexion</span>
              <span className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-red-400">
                ↗
              </span>
            </motion.button>
          </Popconfirm>
        </div>
      </nav>

      {/* Modale pour changer d'agence */}
      {showAgencySwitch && (
        <div className="absolute mb-8 bottom-0 left-0 mt-12 ml-3 bg-white shadow-lg rounded-lg p-4 w-64 z-10">
          <h3 className="text-lg font-semibold mb-3">Choisir une agence</h3>
          <ul className="space-y-2">
            {[
              { name: "Asnieres", _id: "650adee7951dd697c7535e3e" },
              { name: "Brive", _id: "6533fe25099978decf532a59" },
              { name: "Toulouse", _id: "654a3d82874a059df3f98653" },
            ].map((agency, idx) => (
              <li key={idx}>
                <button
                  onClick={() => switchAgency(agency.name, agency._id)}
                  className="w-full text-left px-3 py-2 rounded hover:bg-gray-100"
                >
                  {agency.name}
                </button>
              </li>
            ))}
          </ul>
          <button
            onClick={closeAgencyModal}
            className="mt-4 text-sm text-gray-500 hover:text-gray-700"
          >
            Annuler
          </button>
        </div>
      )}

      {/* Footer */}
      <div className="py-3 px-6 border-t border-gray-700/50 flex-shrink-0">
        <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-600/30 to-transparent"></div>
      </div>
    </motion.aside>
  );
}
